/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILobasArticleData } from './lobas-article.data';
import { ILobasArticleProps } from './lobas-article.props.autogenerated';
import { IArticleViewProps } from './components/articleView';
import { IModuleProps } from '@msdyn365-commerce-modules/utilities';

export interface ILobasArticleViewProps extends ILobasArticleProps<ILobasArticleData> {
    articleViewProps: IArticleViewProps;
    articleProps: IModuleProps;
}

/**
 *
 * LobasArticle component
 * @extends {React.PureComponent<ILobasArticleProps<ILobasArticleData>>}
 */
class LobasArticle extends React.PureComponent<ILobasArticleProps<ILobasArticleData>> {
    public render(): JSX.Element | null {
        const articleResult = this.props.data.articles;

        // Still loading — render nothing yet.
        if (articleResult.status === 'LOADING') {
            return null;
        }

        // Resolved but the article was not found — show the not-found message instead of a blank page.
        if (!articleResult.result) {
            return <div className='lobasArticle lobasArticle--notFound'>{this.props.resources.noArticleLabel}</div>;
        }

        const viewProps = {
            ...this.props,
            articleViewProps: {
                article: articleResult.result,
                locale: this.props.context.request.locale,
                resources: this.props.resources,
                className: this.props.config.className,
                context: this.props.context
            },
            articleProps: {
                moduleProps: this.props,
                className: '',
                tag: 'div'
            }
        };

        return this.props.renderView(viewProps);
    }
}

export default LobasArticle;
